// Minimal JWT payload decode (no signature verification — that's the
// backend's job). Used only to check client-side whether a stored token
// has already expired, so the UI doesn't show a session as active forever.
export const getJwtExpiration = (token: string): number | null => {
  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(base64));
    return typeof payload.exp === 'number' ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};

export const isJwtExpired = (token: string): boolean => {
  const expiresAt = getJwtExpiration(token);
  if (expiresAt === null) return true;
  return Date.now() >= expiresAt;
};
